import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const UPGRADE_LINK = `${getFullUrl('app')}/pricing/${PortalIdParser.get()}`;
export const UpgradeButton = () => /*#__PURE__*/_jsx(Button, {
  size: "extra-small",
  use: "tertiary",
  href: UPGRADE_LINK,
  target: "_blank",
  "data-test-id": "upgrade-button",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.whatsapp.sendActions.buttonLabels.upgrade"
  })
});
UpgradeButton.displayName = 'UpgradeButton';
export const ViewConversationButton = ({
  threadId,
  track
}) => /*#__PURE__*/_jsx(Button, {
  size: "extra-small",
  use: "tertiary",
  target: "_blank",
  onClick: () => {
    if (track) track();
    window.open(`${getFullUrl('app')}/live-messages/${PortalIdParser.get()}/inbox/${threadId}#whatsapp`);
  },
  "data-test-id": "view-conversation-button",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.whatsapp.sendActions.buttonLabels.viewConv"
  })
});
ViewConversationButton.displayName = 'ViewConversationButton';
export const SendTemplateButton = ({
  disabledReason,
  openIframe
}) => {
  const templateButton = /*#__PURE__*/_jsx(Button, {
    size: "extra-small",
    use: "tertiary",
    disabled: !!disabledReason,
    onClick: openIframe,
    "data-test-id": "send-template-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.whatsapp.sendActions.buttonLabels.sendTemplate"
    })
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledReason,
    children: templateButton
  });
};
SendTemplateButton.displayName = 'SendTemplateButton';
export const NewConversationButton = ({
  openIframe,
  track
}) => /*#__PURE__*/_jsx(Button, {
  size: "extra-small",
  use: "tertiary-light",
  onClick: () => {
    if (track) track();
    openIframe();
  },
  "data-test-id": "start-new-conversation-button",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.whatsapp.sendActions.buttonLabels.startNewConv"
  })
});
NewConversationButton.displayName = 'NewConversationButton';